// ─────────────────────────────────────────────────────────────────────────────
// Discounts feature — API давхарга. Хямдрал + бонус дүрэм.
// ─────────────────────────────────────────────────────────────────────────────
import AxiosRequest from "shared/api/httpClient";

/** Барааны жагсаалт хямдрал/бонусын төлөвтэйгөөр. */
export async function getMerchantDiscounts(body) {
  return AxiosRequest({
    url: "/merchant/products/discount",
    method: "post",
    data: body,
  });
}

/** Бараанд хямдрал үүсгэх. */
export async function createProductDiscount(body) {
  return AxiosRequest({
    url: "/merchant/createProductDiscount",
    method: "post",
    data: body,
  });
}

/** Хямдралыг цуцлах. */
export async function cancelProductDiscount(body) {
  return AxiosRequest({
    url: "/merchant/cancelProductDiscount",
    method: "post",
    data: body,
  });
}

/** Бонус дүрэм үүсгэх. */
export async function createBonusRule(body) {
  return AxiosRequest({
    url: "/merchant/createBonusRule",
    method: "post",
    data: body,
  });
}
